"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconComplete = _interopRequireDefault(require("@cx/ui/Icons/IconComplete"));

var _IconBullet = _interopRequireDefault(require("@cx/ui/Icons/IconBullet"));

require("./_PCW.scss");

var _reactI18next = require("react-i18next");

var _i18n = _interopRequireDefault(require("../i18n"));

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * The PCW ("Password Coaching Widget") component displays a list of password requirements
 * and whether or not those requirements have been satisfied by a provided input string.
 *
 * Validated items will be marked with an X if the requirement is not met OR a check if that requirement is met.
 * Items that are not validated through front end validation are denoted with a bullet point.
 */


var PCW = /*#__PURE__*/function (_React$Component) {
  _inherits(PCW, _React$Component);

  var _super = _createSuper(PCW);

  function PCW(props) {
    var _this;

    _classCallCheck(this, PCW);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "displayRequirement", function (item) {
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "requirement",
        key: item.infoMessage + Math.random().toString(36).substring(5)
      }, item.PCWRegex && item.complete && /*#__PURE__*/_react.default.createElement(_IconComplete.default, {
        className: "completeRequirement"
      }), item.PCWRegex && !item.complete && /*#__PURE__*/_react.default.createElement(_IconComplete.default, {
        className: "incompleteRequirement"
      }), !item.PCWRegex && /*#__PURE__*/_react.default.createElement(_IconBullet.default, {
        className: "bullet"
      }), item.infoMessage);
    });

    _defineProperty(_assertThisInitialized(_this), "checkValue", function (item, value) {
      var _this$props = _this.props,
          mode = _this$props.mode,
          passwordPolicy = _this$props.passwordPolicy;
      var validationStatus = {
        isValid: true,
        errorMessages: []
      };
      item.map(function (item) {
        if (!item.policy || !passwordPolicy && item.policy.includes(_constants.STANDARD) || item.policy.includes(passwordPolicy)) {
          if (!item.hide || !item.hide.includes(mode)) {
            var PCWRegex = new RegExp(item.PCWRegex);
            item.complete = PCWRegex.test(value);
            item.validations.map(function (validation) {
              if (validation.regex) {
                var regex = new RegExp(validation.regex);
                validation.complete = regex.test(value);
                validationStatus.isValid = validationStatus.isValid && validation.complete;
                !validation.complete && !validationStatus.errorMessages.includes(validation.errorMessage) && // make sure the message was not added before
                validationStatus.errorMessages.push(validation.errorMessage);
              }
            });
          }
        }

        return validationStatus;
      });

      _this.setState({
        requirement_musts: item
      });

      return validationStatus;
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function (value) {
      var _this$checkValue = _this.checkValue(_this.state.requirement_musts, value),
          isValid = _this$checkValue.isValid,
          errorMessages = _this$checkValue.errorMessages;

      _this.props.checkValidity(isValid, errorMessages);
    });

    _this.state = {
      /**
       * requirement_musts: an array of requirements that the input string will be tested against on the front end
       *  {
       *  infoMessage : STRING for what is to be displayed if the validation fails
       *  validations : [
       *    complete[BOOLEAN] indicates if the input string matches the requirement
       *    regex[STRING] the regex string to check the input against
       *    errorMessage[STRING] the message to display if validation fails,
       *    policy[List<STRING>] an array of password policies that contain this requirement, if no policy list is present the requirement is always included.
       *  }
       *
       *  The infoMessages here should all be phrases that grammatically can follow "Your password must:".
       *  The errorMessages here should all be complete sentences, not sentence fragments.
       **/
      requirement_musts: [{
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_CHARACTER_COUNT),
        // "Be between 8-72 characters long"
        PCWRegex: "^.{8,72}$",
        complete: false,
        validations: [{
          regex: "^.{8,}$",
          complete: false,
          errorMessage: _i18n.default.t(_constants.PCW_MESSAGE_PASSWORD_TOO_SHORT) // "Password must be at least 8 characters long."

        }, {
          regex: "^.{0,72}$",
          complete: false,
          errorMessage: _i18n.default.t(_constants.PCW_MESSAGE_PASSWORD_TOO_LONG) // "Password must be fewer than 72 characters long."

        }] // no policy means, this rule works for all policies

      }, {
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_CONTAIN_LETTER_AND_NUMBER),
        // "Contain at least one letter and one number"
        PCWRegex: "^(?=.*?[a-zA-Z])(?=.*?[0-9])",
        complete: false,
        validations: [{
          regex: "[0-9]",
          // Password must contain at least a number
          complete: false,
          errorMessage: _i18n.default.t(_constants.PCW_MESSAGE_PASSWORD_NEEDS_NUMBER) // "Password must contain at least one number."

        }, {
          regex: "[A-Za-z]",
          // Password must contain a at least one letter.
          complete: false,
          errorMessage: _i18n.default.t(_constants.PCW_MESSAGE_PASSWORD_NEEDS_LETTER) // "Password must contain at least one letter."

        }],
        policy: [_constants.LEGACY]
      }, {
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_CONTAIN_LETTER_OR_NUMBER),
        // "Contain at least one letter or one number"
        PCWRegex: ".*[a-zA-Z0-9].*",
        complete: false,
        validations: [{
          regex: ".*[a-zA-Z0-9].*",
          complete: false,
          errorMessage: _i18n.default.t(_constants.PCW_MESSAGE_PASSWORD_NEEDS_LETTER_OR_NUMBER) // "Password must contain at least one letter or one number."

        }],
        policy: [_constants.STANDARD]
      }],

      /**
       * requirement_may_not_contains: an array of requirements that the input string will be tested against on the back end
       *  {
       *    infoMessage[STRING] displayed text for the user
       *    hide[LIST<STRING>] an array of modes that the requirement does not apply to
       *  }
       *
       *  The infoMessages here should all be phrases that grammatically can follow "Your password may not contain:".
       **/
      requirement_may_not_contains: [{
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_SINGULAR_COX_BRANDS) // "Singular Cox Automotive brand names"

      }, {
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_PERSONAL_INFO) // "Easily obtained personal information"

      }, {
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_REPEATED_PATTERNS) // "Repeated or sequential character patterns"

      }, {
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_COMMON_BAD_PASSWORDS) // "Known common passwords"

      }, {
        infoMessage: _i18n.default.t(_constants.PCW_REQUIREMENT_PREVIOUS_PASSWORDS),
        // "Previously used passwords"
        hide: ["register"]
      }]
    };
    return _this;
  }

  _createClass(PCW, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateInput(this.props.password);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.password !== prevProps.password) {
        this.validateInput(this.props.password);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var requirement_musts = this.state.requirement_musts;
      var requirement_may_not_contains = this.state.requirement_may_not_contains;
      var _this$props2 = this.props,
          mode = _this$props2.mode,
          passwordPolicy = _this$props2.passwordPolicy,
          htmlId = _this$props2.htmlId;

      var requirementsList = /*#__PURE__*/_react.default.createElement("div", {
        className: "inputRequirements"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "requirementsHeading"
      }, _i18n.default.t(_constants.PCW_REQUIREMENT_PASSWORD_MUST)), requirement_musts.map(function (item) {
        if (!item.policy || !passwordPolicy && item.policy.includes(_constants.STANDARD) || item.policy.includes(passwordPolicy)) {
          return _this2.displayRequirement(item);
        }

        return "";
      }), /*#__PURE__*/_react.default.createElement("p", {
        className: "requirementsHeading"
      }, _i18n.default.t(_constants.PCW_REQUIREMENT_PASSWORD_MAY_NOT_CONTAIN)), requirement_may_not_contains.map(function (item) {
        if (!item.hide || !item.hide.includes(mode)) {
          return _this2.displayRequirement(item);
        }

        return "";
      }));

      return /*#__PURE__*/_react.default.createElement("div", {
        id: htmlId
      }, requirementsList);
    }
  }]);

  return PCW;
}(_react.default.Component);

PCW.propTypes = {
  checkValidity: _propTypes.default.func.isRequired,
  htmlId: _propTypes.default.string.isRequired,
  mode: _propTypes.default.oneOf(["register", "update"]),
  password: _propTypes.default.string.isRequired,
  passwordPolicy: _propTypes.default.oneOf([_constants.STANDARD, _constants.LEGACY])
};

var _default = (0, _reactI18next.withTranslation)()(PCW);

exports.default = _default;